/* eslint-disable class-methods-use-this */
const manager = {
  getItem: (key: string) => localStorage.getItem(key),
  setItem: (key: string, value: string) => localStorage.setItem(key, value),
  removeItem: (key: string) => localStorage.removeItem(key),
};

export const TOKEN_APP = 'X-JustRPC-Token';
export const TOKEN_APP_AUX = 'X-JustRPC-Token-Aux';

export class TokenManager {
  retrieve(): string | null {
    try {
      const token = manager.getItem(TOKEN_APP);
      return token;
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      return null;
    }
  }

  clean(): void | boolean {
    try {
      return manager.removeItem(TOKEN_APP);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      return false;
    }
  }

  persist(token: string): void | boolean {
    try {
      return manager.setItem(TOKEN_APP, token);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      return false;
    }
  }

  static create(): TokenManager {
    return new TokenManager();
  }
}

export const tokenManager = TokenManager.create();

const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error getting item [${key}] from localStorage:`, error);
    return null;
  }
};

const setItem = (key: string, value: string): boolean => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error(`Error setting item [${key}] in localStorage:`, error);
    return false;
  }
};

const removeItem = (key: string): boolean => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error(`Error removing item [${key}] from localStorage:`, error);
    return false;
  }
};

export const isValidToken = (token: string | null): token is string =>
  !!token && token !== 'undefined' && token.trim() !== '';

export const getActiveToken = (): string | null => {
  const main = getItem(TOKEN_APP);
  const aux = getItem(TOKEN_APP_AUX);

  if (isValidToken(main)) return main;
  if (isValidToken(aux)) return aux;

  return null;
};

export const cleanTokens = (): void => {
  removeItem(TOKEN_APP);
  removeItem(TOKEN_APP_AUX);
};

// token principal
export const retrieveToken = (): string | null => getItem(TOKEN_APP);
export const persistToken = (token: string): boolean => setItem(TOKEN_APP, token);
export const cleanToken = (): boolean => removeItem(TOKEN_APP);

// token aux
export const retrieveAuxToken = (): string | null => getItem(TOKEN_APP_AUX);
export const persistAuxToken = (token: string): boolean => setItem(TOKEN_APP_AUX, token);
export const cleanAuxToken = (): boolean => removeItem(TOKEN_APP_AUX);
